import { lazy } from "react";
import type { RouteObject } from "react-router";
import { RESUME_ROUTES } from "@/src/resume/constants/resume-routes.constants";

const ResumeBuilderPage = lazy(() => import("@/src/resume/pages/resume-builder.page"));

export const resumeStudentRoutes: RouteObject[] = [{ path: RESUME_ROUTES.builder, element: <ResumeBuilderPage /> }];
